import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivityLogService, ActivityLog } from '../../../services/activity-log.service';
import { PrimengImports } from '../../../shared/primeng-imports';

@Component({
  selector: 'app-superadmin-activity',
  standalone: true,
  imports: [CommonModule, FormsModule, PrimengImports],
  templateUrl: './superadmin-activity.component.html',
  styleUrl: './superadmin-activity.component.css'
})
export class SuperadminActivityComponent implements OnInit {
  logs: ActivityLog[] = [];
  filteredLogs: ActivityLog[] = [];
  loading: boolean = false;
  error: string = '';

  // Pagination
  currentPage: number = 1;
  pageSize: number = 20;
  totalLogs: number = 0;
  totalPages: number = 0;

  constructor(private activityLogService: ActivityLogService) {}

  ngOnInit(): void {
    this.loadActivityLogs();
  }

  loadActivityLogs(): void {
    this.loading = true;
    this.error = '';

    // Load all activity logs without pagination
    this.activityLogService.getActivityLogs({}).subscribe({
      next: (response) => {
        if (response.success && response.data && Array.isArray(response.data)) {
          this.logs = response.data;
          this.setupPagination();
        } else {
          this.error = 'Failed to load activity logs';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading activity logs:', err);
        this.error = 'Failed to load activity logs. Please try again.';
        this.loading = false;
      }
    });
  }

  setupPagination(): void {
    this.totalLogs = this.logs.length;
    this.totalPages = Math.ceil(this.totalLogs / this.pageSize);
    this.updateFilteredLogs();
  }

  updateFilteredLogs(): void {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.filteredLogs = this.logs.slice(startIndex, endIndex);
  }

  onPageChange(event: any): void {
    this.currentPage = event.page + 1;
    this.pageSize = event.rows;
    this.updateFilteredLogs();
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  refreshLogs(): void {
    this.loadActivityLogs();
  }
}
